import type { MutableRefObject, Ref } from 'react';

export const mergeRefs = <T>(...refs: (Ref<T> | undefined | null)[]) => {
  return (value: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref && 'current' in ref) {
        const mutableRef = ref as MutableRefObject<T | null>;
        mutableRef.current = value;
      }
    }
  };
};
